import { render, staticRenderFns } from "./JourneySummaryAlt.vue?vue&type=template&id=0568dbf0&"
import script from "./JourneySummaryAlt.vue?vue&type=script&lang=js&"
export * from "./JourneySummaryAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports